<template>
  <div v-if="loading && !list.length" class="select-list empty-state">
    <van-loading color="black" />
  </div>
  <div v-else-if="!loading && !list.length" class="select-list empty-state">
    <svg-icon icon="empty-default" />
    <p>{{emptyText}}</p>
  </div>
  <div v-else class="select-list">
    <div class="loading-indicator" v-if="loading && list.length">
      <i class="circle-icon-loading"/>
      <span>{{$t('base.loading')}}</span>
    </div>
    <div v-if="atAll" class="select-item at-all" @click="handleAtAll">
      <div class="at-all-avatar primary-bgcolor">all</div>
      {{$t('contact.atAllCollaber')}}
    </div>
    <div class="select-item" v-for="(typed_id, index) in list" :key="`${typed_id}_${index}`" @click="selectUser(index, entities[typed_id])">
      <van-checkbox
        v-if="showCheckbox"
        v-model="entities[typed_id].checked"
        shape="round"
        @click.stop="selectUser(index, entities[typed_id])"
        :disabled="entities[typed_id].disabled || entities[typed_id].disableCheckbox"
        ref="checkbox"
      />
      <avatar
        v-if="entities[typed_id].is_department || entities[typed_id].is_group"
        class="thumb-icon"
        :type="entities[typed_id].is_department ? 'department' : 'group'"
        :size="36"
      />
      <avatar
        v-else
        class="thumb-icon"
        :user="entities[typed_id]"
        :isActive="entities[typed_id].is_active"
        :size="36"
      />
      <div class="item-main has-border-bottom">
        <div class="item-name ellipsis">
          <span v-html="entities[typed_id].highlightName || entities[typed_id].name"></span>
          <span class="primary-color" v-if="entities[typed_id].current_user">({{$t('contact.includingMe')}})</span>
        </div>
        <div class="item-meta ellipsis" v-html="entities[typed_id].info"></div>
      </div>
      <div v-if="showDelete" class="item-action has-border-bottom" @click="deleteAction(typed_id, index)">
        <span class="delete">-</span>
      </div>
    </div>
  </div>
</template>
<script>
import Avatar from '../utils/Avatar'

export default {
  name: 'ContactList',
  components: {
    Avatar
  },
  props: {
    list: Array,
    entities: Object,
    loading: Boolean,
    atAll: {
      type: Boolean,
      default: false
    },
    emptyText: String,
    showCheckbox: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleAtAll () {
      this.$emit('select-all')
    },
    selectUser (index, user) {
      if (user.disabled || !this.showCheckbox) return
      this.$emit('select', user)
      this.$refs.checkbox[index].toggle()
    },
    deleteAction (typed_id, index) {
      this.$emit('add-delete-id', typed_id, index)
    }
  }
}
</script>
<style lang="postcss">
</style>
